import styled from "styled-components";
import {Title1} from "../../../../styles/business-components";
import {Button} from "../../../Button/styles";

export const Content = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 100px;
`

export const Stories = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`

export const StoryTextBlock = styled.div`
  width: 90%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    gap: 20px;
  }
`

export const StoryGlider = styled.div`
  background: ${({theme}) => theme.business.colors.storyBackground};
  width: 650px;
  height: 150px;
  padding: 20px;
  border-radius: 125px 125px 125px 1px;
  border: 1px;
  transition: width 0.3s linear, visibility 0.3s linear;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    width: 860px;
    height: 250px;
  }
`

export const StoryTitle = styled.div`
  margin-left: 180px;
  font-size: 20px;
  line-height: 28px;  
  font-weight: 400;
  text-align: left;
  text-transform: uppercase;
  color: ${({theme}) => theme.business.colors.primary};

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    margin-left: 280px;
    font-size: 28px;
    line-height: 38px;
  }
`

export const StoryText = styled.div`
  margin-left: 180px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  text-align: left;
  overflow: hidden;
  color: ${({theme}) => theme.business.colors.textColor};

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    margin-left: 280px;
    font-size: 20px;
    line-height: 40px;
  }
`

export const StoryButton = styled(Button)`
  position: absolute;
  visibility: hidden;
  top: 50px;
  left: 180px;
  text-transform: uppercase;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    top: 100px;
    left: 300px;
  }
`

export const StoryImage = styled.img`
  position: absolute;
  width: 150px;
  height: 150px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    width: 250px;
    height: 250px;
  }
`

export const Story = styled.div`
  width: 100%;
  height: max-content;
  position: relative;
  &:hover {
    ${StoryGlider} {
      white-space: nowrap;
      overflow: hidden;
      width: 200px;
      visibility: hidden;
    }
    
    ${StoryTextBlock} {
      visibility: hidden;
    }
    
    ${StoryButton} {
      visibility: visible;
    }
   }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  opacity: 1;
`

export const Title = styled(Title1)`
  margin: 0;
  white-space: pre-line;
  font-size: 28px;
  line-height: 40px;
  font-weight: 600;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 40px;
    line-height: 70px;
  }
`